import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-85804cbc"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "home-page-root"
};
const _hoisted_2 = {
  class: "main-scroll-bottombar-content"
};
const _hoisted_3 = ["id", "src"];

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://summit-img.geekpark.net/if2023/home_gif_4.gif",
  alt: "极客公园创新大会2023"
}, null, -1));

const _hoisted_5 = {
  key: 0,
  class: "cloun-photo-btn"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.eventnet.cn/if2023/"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://summit-img.geekpark.net/if2023/home_cloud_photo_btn.png",
  alt: "云相册按钮"
})], -1));

const _hoisted_7 = [_hoisted_6];

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://summit-img.geekpark.net/if2023/home_intraction_2.png",
  alt: "极客公园创新大会2023"
}, null, -1));

const _hoisted_9 = {
  class: "home-video-box"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "home-video-box-bg",
  src: "https://summit-img.geekpark.net/if2023/home_video_bg_4.png",
  alt: "极客公园创新大会2023"
}, null, -1));

const _hoisted_11 = {
  class: "home-video-container"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  type: "video/mp4",
  src: "https://summit-img.geekpark.net/if2023/home_video_come_up.mp4"
}, null, -1));

const _hoisted_13 = [_hoisted_12];
const _hoisted_14 = {
  class: "home-video-box about-home-video-box"
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "home-video-box-bg",
  src: "https://summit-img.geekpark.net/if2023/aboutif_home_video_bg_4.jpg"
}, null, -1));

const _hoisted_16 = {
  class: "home-video-container"
};

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  type: "video/mp4",
  src: "https://summit-img.geekpark.net/if2023/about_if.mp4"
}, null, -1));

const _hoisted_18 = [_hoisted_17];

const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"other-if-box\" data-v-85804cbc><img src=\"https://summit-img.geekpark.net/if2023/about_if_content_6.png\" data-v-85804cbc><div class=\"other-if-item-box\" data-v-85804cbc><div class=\"other-if-item\" data-v-85804cbc><a class=\"other-if-text\" href=\"https://if2015.geekpark.net/\" data-v-85804cbc>2015</a><a class=\"other-if-text\" href=\"https://if2016.geekpark.net/\" data-v-85804cbc>2016</a></div><div class=\"other-if-item\" data-v-85804cbc><a class=\"other-if-text\" href=\"http://if2017.geekpark.net/\" data-v-85804cbc>2017</a><a class=\"other-if-text\" href=\"http://if2018.geekpark.net/\" data-v-85804cbc>2018</a></div><div class=\"other-if-item\" data-v-85804cbc><a class=\"other-if-text\" href=\"https://if2019.geekpark.net/\" data-v-85804cbc>2019</a><a class=\"other-if-text\" href=\"https://if2020.geekpark.net/\" data-v-85804cbc>2020</a></div><div class=\"other-if-item\" data-v-85804cbc><a class=\"other-if-text\" href=\"https://if2021.geekpark.net/\" data-v-85804cbc>2021</a><a class=\"other-if-text\" href=\"https://if2022.geekpark.net/\" data-v-85804cbc>2022</a></div></div></div>", 1);

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://summit-img.geekpark.net/if2023/footer_2.png"
}, null, -1));

const _hoisted_21 = {
  class: "share-img-wrapper"
};

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "share-img",
  src: "https://summit-img.geekpark.net/if2023/home_fixed_banner.png"
}, null, -1));

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "long-press-wrapper"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "long-press-tip"
}, "长按上图保存或分享")], -1));

import { ref, onBeforeMount, onMounted, onUpdated, onBeforeUnmount } from "vue";
import { Dialog } from "vant";
import router from "../router";
import dayjs from "dayjs";
export default {
  __name: 'Home',

  setup(__props) {
    const VanDialog = Dialog.Component;
    const imgSrcs1 = [, "https://summit-img.geekpark.net/if2023/home_intraction_2.png"];
    const imgSrcs2 = ["https://summit-img.geekpark.net/if2023/home_top_light__4.png", "https://summit-img.geekpark.net/if2023/home_tekan_2.png", "https://summit-img.geekpark.net/if2023/home_guest_8.jpg", "https://summit-img.geekpark.net/if2023/home_display_3.png", "https://summit-img.geekpark.net/if2023/home_about_3.png"];
    const imgSrcs3 = ["https://summit-img.geekpark.net/if2023/home_allif_1.png", "https://summit-img.geekpark.net/if2023/home_allif_2.png"];
    const imgSrcs4 = ["https://summit-img.geekpark.net/if2023/home_contact_3.png", "https://summit-img.geekpark.net/if2023/home_contact_content_4.png", "https://summit-img.geekpark.net/if2023/home_partner_3.png", "https://summit-img.geekpark.net/if2023/partner_4.png"];
    onBeforeMount(() => {
      checkIfIsStart();
    });
    onMounted(() => {
      video1.value && video1.value.addEventListener("play", handlePlay1);
      video2.value && video2.value.addEventListener("play", handlePlay2); //监听滚动

      window.addEventListener("scroll", handleScroll, true);
    });
    onUpdated(() => {});
    onBeforeUnmount(() => {
      video1.value && video1.value.pause(); //暂停视频

      video2.value && video2.value.pause(); //暂停视频

      window.removeEventListener("scroll", handleScroll, true);
    });
    const ifIsStart = ref(false);
    const showCloud = ref(false);

    const checkIfIsStart = () => {
      const ifTime = dayjs("2022-12-17T00:00:00+08:00");

      if (ifTime <= dayjs()) {
        ifIsStart.value = true;
        showCloud.value = true;
      } else {
        ifIsStart.value = false;
        showCloud.value = false;
      }
    }; // 视频播放


    const isFirst1 = ref(false);
    const video1 = ref(null); //视频播放状态

    const handlePlay1 = () => {
      if (!isFirst1.value) {
        video1.value.pause();
        video1.value.play();
        isFirst1.value = true;
      }
    }; // 视频播放


    const isFirst2 = ref(false);
    const video2 = ref(null); //视频播放状态

    const handlePlay2 = () => {
      if (!isFirst2.value) {
        video2.value.pause();
        video2.value.play();
        isFirst2.value = true;
      }
    }; //页面滚动


    const handleScroll = () => {
      video1.value && video1.value.pause(); //暂停视频

      video2.value && video2.value.pause(); //暂停视频
    }; // 处理分享海报弹出


    const showDialog = ref(false);

    const handleShare = () => {
      showDialog.value = true;
    }; // 关闭分享弹窗回调


    const onCloseShareDialog = () => {}; // 关闭分享弹窗


    const closeShareImagDialog = () => {
      showDialog.value = false;
    }; // 购票、核销


    const handleHomeBtn = () => {
      if (ifIsStart.value) {
        router.push("/my-tickets");
      } else {
        router.push("/buy");
      }
    };

    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");

      const _directive_lazy = _resolveDirective("lazy");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        src: "https://summit-img.geekpark.net/if2023/home_share_btn.png",
        class: "home-share-btn",
        id: "ga4-home-share",
        alt: "分享按钮",
        onClick: handleShare
      }), _createElementVNode("img", {
        id: ifIsStart.value ? '' : 'ga4-home-buy-now',
        src: ifIsStart.value ? 'https://summit-img.geekpark.net/if2023/write_off_btn.png' : 'https://summit-img.geekpark.net/if2023/buy_ticket_btn_3.png',
        class: "home-fixed-btn",
        alt: "购票、核销按钮",
        onClick: handleHomeBtn
      }, null, 8, _hoisted_3), _hoisted_4, showCloud.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)) : _createCommentVNode("", true), _hoisted_8, _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("video", {
        class: "home-video-player",
        ref_key: "video1",
        ref: video1,
        poster: "https://summit-img.geekpark.net/if2023/home_video_come_up_cover.jpg",
        controlslist: "nodownload noremoteplayback",
        controls: "controls",
        disablePictureInPicture: "",
        loop: "",
        "webkit-playsinline": "",
        playsinline: "",
        "x5-playsinline": ""
      }, _hoisted_13, 512)])]), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(imgSrcs2, imgSrc => {
        return _withDirectives(_createElementVNode("img", {
          key: imgSrc,
          alt: "极客公园创新大会2023"
        }), [[_directive_lazy, imgSrc]]);
      }), 64)), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, [_createElementVNode("video", {
        class: "home-video-player",
        ref_key: "video2",
        ref: video2,
        poster: "https://summit-img.geekpark.net/if2023/about_if_cover_img.jpg",
        controlslist: "nodownload noremoteplayback",
        controls: "controls",
        disablePictureInPicture: "",
        loop: "",
        "webkit-playsinline": "",
        playsinline: "",
        "x5-playsinline": ""
      }, _hoisted_18, 512)])]), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(imgSrcs3, imgSrc => {
        return _withDirectives(_createElementVNode("img", {
          key: imgSrc,
          alt: "极客公园创新大会2023"
        }), [[_directive_lazy, imgSrc]]);
      }), 64)), _hoisted_19, (_openBlock(), _createElementBlock(_Fragment, null, _renderList(imgSrcs4, imgSrc => {
        return _withDirectives(_createElementVNode("img", {
          key: imgSrc,
          alt: "极客公园创新大会2023"
        }), [[_directive_lazy, imgSrc]]);
      }), 64)), _hoisted_20]), _createVNode(_unref(VanDialog), {
        class: "share-img-dialog",
        show: showDialog.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => showDialog.value = $event),
        onClose: onCloseShareDialog,
        showConfirmButton: false,
        closeOnClickOverlay: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_hoisted_22, _hoisted_23, _createVNode(_component_van_icon, {
          class: "close-share-img-icon",
          name: "close",
          color: "#fff",
          onClick: closeShareImagDialog
        })])]),
        _: 1
      }, 8, ["show"])]);
    };
  }

};